<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            Videos</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tiêu đề:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Tên video..." v-model="search.cTenVideo" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option label="Hoạt động" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news" :disabled="!handleCheckPerms('sys:videos:add')">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm Video</span>
            </el-button>
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="nMaVideo" label="Mã" align="center" width="80"></el-table-column>
            <el-table-column prop="cTenVideo" show-overflow-tooltip class="text-nowrap" label="Tiêu đề">
            </el-table-column>
            <el-table-column prop="cVideoUrl" show-overflow-tooltip class="text-nowrap" label="Đường dẫn">
              <template #default="scope">
                <span class="copy-url" @click="copyUrl(baseUrl + '/view' + scope.row.cVideoUrl)">
                  {{ baseUrl + "/view" + scope.row.cVideoUrl }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="250">
              <template #default="scope">
                <el-button
                  plain
                  type="success"
                  title="Xem video"
                  @click="handlePlayVideo(scope.row)"
                >
                  <i class="fas fa-play"></i>
                </el-button>
                <el-button plain type="primary"
                  :disabled="scope.row.nTrangThai == 0 || !handleCheckPerms('sys:videos:edit')" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>
                <el-button plain type="danger"
                  :disabled="scope.row.nTrangThai == 0 || !handleCheckPerms('sys:videos:delete')"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm video" : "Cập nhật video" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-600px overflow-scroll">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="120px" class=" d-flex flex-column">
              <el-form-item label="Tên video" prop="cTenVideo">
                <el-input v-model="formData.cTenVideo" />
              </el-form-item>
              <el-form-item v-if="formData.cLoaiVideo === 'embed'" label="Tên video" prop="cVideoUrl">
                <el-input v-model="formData.cVideoUrl" />
              </el-form-item>
              <el-form-item v-else label="Video" prop="attachmentFile">
                <el-upload action="#" :auto-upload="false" placeholder="Chọn đính kèm" ref="uploadAttachment"
                  :file-list="attachmentFile" accept=".mp4" :on-change="handleChangeAttachment"
                  :on-remove="handleRemoveAttachment">
                  <el-button :type="attachmentFile.length == 0 ? 'primary' : 'warning'">
                    <i class="el-icon-plus fw-bolder" v-if="attachmentFile.length == 0"></i>
                    <i class="el-icon-refresh fw-bolder" v-if="attachmentFile.length > 0"></i>
                  </el-button>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="videoDialogVisible"
      width="900px"
      destroy-on-close
    >
      <template #header>
        <strong>Xem video</strong>
      </template>

      <video
        v-if="videoUrl"
        :src="videoUrl"
        controls
        autoplay
        style="width:100%; max-height:70vh"
      />
    </el-dialog>
  </div>
</template>
<script>
import { Videos, Zalo } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from "@/utils/global";
import { ElMessage } from "element-plus";
import { CookieComponent } from "@/assets/ts/components";


export default {
  name: 'videos',
  data() {
    return {
      perms: CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions")) : [],
      loadText: false,
      search: {
        cTenVideo: "",
        nTinhTrang: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      baseUrl: baseUrl,
      formData: {
        cTenVideo: "",
        attachmentFile: [],
      },
      rules: {
        cTenVideo: [{ required: true, message: "Xin vui lòng điền tiêu đề", trigger: "blur" }],
        cVideoUrl: [{ required: true, message: "Xin vui lòng điền đường dẫn video nhúng", trigger: "blur" }],
        attachmentFile: [
          {
            required: true, message: 'Xin vui lòng chọn bản ghi', trigger: 'change', validator: (rule, value, callback) => {
              if (this.attachmentFile.length === 0) {
                callback(new Error('Xin vui lòng chọn bản ghi'));
              } else {
                callback();
              }
            }
          },
        ],
      },
      tableData: {
        content: []
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      attachmentFile: [],
      dialogImageUrl: null,
      dialogVisible: false,
      articalType: [],
      videoUrl: "",
      videoDialogVisible: false
    }
  },
  methods: {
    handlePlayVideo(row) {
      this.videoUrl = this.baseUrl + "/view" + row.cVideoUrl
      this.videoDialogVisible = true
    },
    async copyUrl(url){
      try {
        await navigator.clipboard.writeText(url)
        ElMessage.success('Đã copy đường dẫn')
      } catch (err) {
        ElMessage.error('Không thể copy')
      }
    },
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {}
      this.attachmentFile = []
    },
    async handleOpenEdit(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = true
      this.loadText = false
      this.formData = Object.assign({}, val)
      this.attachmentFile = []
      if (val.cVideoUrl) {
        this.isLoading = true
        await this.addAttachmentFromURL(baseUrl + val.cVideoUrl)
        this.isLoading = false
      }
    },
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa video này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Videos.deleteVideos, val).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa video thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa video thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cTenVideo: { value: this.search.cTenVideo },
        cLoaiVideo: { value: this.search.cLoaiVideo },
        nTinhTrang: { value: this.search.nTinhTrang },
      }
      this.store.dispatch(Videos.showVideos, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm video thất bại", type: "error" });
      })
    },

    async handleChangeAttachment(file, attachmentFile) {
      this.attachmentFile = [file]
      this.formData.attachmentFile = this.attachmentFile
    },

    handleRemoveAttachment(file, attachmentFile) {
      this.attachmentFile = []
      this.formData.cVideoUrl = ""
      this.formData.attachmentFile = this.attachmentFile
    },

    handleSave() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu video này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          }).then(() => {
            this.isLoading = true
            const formData = new FormData()
            if (this.attachmentFile.length > 0) {
              if (this.attachmentFile[0].status == "ready") {
                formData.append('file', this.attachmentFile[0].raw)
              }
            }
            formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
            if (this.operation) {
              this.store.dispatch(Videos.updateVideos, formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Cập nhật video thành công", type: "success" })
                  this.isLoading = false
                } else {
                  ElMessage({ message: "Cập nhật video không thành công", type: "error" })
                  this.isLoading = false
                }
              }).catch(() => {
                ElMessage({ message: "Cập nhật video không thành công", type: "error" })
                this.isLoading = false
              })
            } else {
              this.store.dispatch(Videos.saveVideos, formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Thêm video mới  thành công", type: "success" })
                  this.isLoading = false
                } else {
                  this.isLoading = false
                  ElMessage({ message: "Thêm video mới không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Thêm video mới không thành công", type: "error" })
                this.isLoading = false
              })
            }
          }).catch(() => {
            this.isLoading = false
          })
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },

    async addAttachmentFromURL(url) {
      const response = await fetch(url);
      console.log(response)
      if (!response.ok) throw new Error('Failed to fetch file');
      const blob = await response.blob();

      const filename = url.split('/').pop().split('?')[0] || `file-${Date.now()}`;
      const file = new File([blob], filename, { type: blob.type || 'application/octet-stream' });

      this.attachmentFile.push({
        name: file.name,
        url: URL.createObjectURL(file),
        status: 'success',
        uid: Date.now(),
        raw: file
      });
    },
    handlePictureCardPreview(val) {
      this.dialogImageUrl = val.url
      this.dialogVisible = true
    },
    handleCheckPerms(val) {
      return this.perms.includes(val)
    }
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss" scoped>

  .copy-url {
    cursor: pointer;
    color: var(--el-color-primary);
  }

  .copy-url:hover {
    text-decoration: underline;
  }
</style>